export const CONCLUSION_STEPS = {
  DRAFT: 0,
  APPROVAL: 1,
} as const

export type ConclusionStep = (typeof CONCLUSION_STEPS)[keyof typeof CONCLUSION_STEPS]
